import * as React from 'react'

const SvgArrowRightWhite = () => (

    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.667 45.3288L45.3337 18.6621M45.3337 18.6621H18.667M45.3337 18.6621V45.3288" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
)


export default SvgArrowRightWhite
